import axios from 'axios';
import { SupportTicketAction } from './support.action';
import { getServerCore, defaultSnackbarTimeout } from '../../../../utils';
import { showSuccessSnackbar } from '../../Snackbar/snackbar.action';

const { serverUrls } = getServerCore();
const defaultUrl = serverUrls.getDefaulUrl();

export const createUserTicketAsync = (ticketDetails, id) => {
    return async (dispatch) => {
        try {
            dispatch(SupportTicketAction.createTicketStart());
            const { data } = await axios({
                method: "POST",
                url: `${defaultUrl}/user/createTicket/${id}`,
                data: ticketDetails
            })
            console.log(data);
            if (data.responseCode === 200) {
                dispatch(SupportTicketAction.createTicketSuccess());
                dispatch(showSuccessSnackbar('success', "Created User Ticket successfully", defaultSnackbarTimeout));
            } else {
                dispatch(SupportTicketAction.createTicketError());
                dispatch(showSuccessSnackbar('error', "Error while creating User Ticket.Please try after some time", defaultSnackbarTimeout));
            }
        } catch (error) {
            dispatch(SupportTicketAction.createTicketError(error.message));
            dispatch(showSuccessSnackbar('error', "Error while creating User Ticket.Please try after some time", defaultSnackbarTimeout));
        }
    }
}

export const getAllUserTicketsAsync = (id, status) => {
    return async (dispatch, getState) => {
        try {
            dispatch(SupportTicketAction.getAllUserTicketsStart());
            let { skip, limit } = getState().supportTicket;
            const { data } = await axios({
                method: "GET",
                url: `${defaultUrl}/user/getAllTickets/${id}?status=${status}&skip=${skip}&limit=${limit}`,
            })
            if (data.responseCode === 200) {
                dispatch(SupportTicketAction.getAllUserTicketsSuccess(data.responseData));
                // dispatch(showSuccessSnackbar('success', data.responseMessage, defaultSnackbarTimeout));
            } else {
                dispatch(SupportTicketAction.getAllUserTicketsError());
                dispatch(showSuccessSnackbar('error', data.responseMessage, defaultSnackbarTimeout));
            }
        } catch (error) {
            dispatch(SupportTicketAction.getAllUserTicketsError(error.message));
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}

const getTicketDetailApi = async (id, ticketId) => {
    return await axios({
        method: "GET",
        url: `${defaultUrl}/user/getTicketDetails/${id}/${ticketId}`,
    })
}
export const getUserTicketDetailsAsync = (id, ticketId) => {
    return async (dispatch) => {
        try {
            dispatch(SupportTicketAction.getTicketDetailsStart());
            const { data } = await axios({
                method: "GET",
                url: `${defaultUrl}/user/getTicketDetails/${id}/${ticketId}`,
            })
            if (data.responseCode === 200) {
                dispatch(SupportTicketAction.getTicketDetailsSuccess(data.responseData));
                // dispatch(showSuccessSnackbar('success', data.responseMessage, defaultSnackbarTimeout));
            } else {
                dispatch(SupportTicketAction.getTicketDetailsError());
                dispatch(showSuccessSnackbar('error', data.responseMessage, defaultSnackbarTimeout));
            }
        } catch (error) {
            dispatch(SupportTicketAction.getTicketDetailsError(error.message));
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}

export const addTicketCommentAsync = (comment, id, ticketId) => {
    return async (dispatch) => {
        try {
            dispatch(SupportTicketAction.addTicketCommentStart());
            const { data } = await axios({
                method: "POST",
                url: `${defaultUrl}/user/addComment/${id}/${ticketId}`,
                data: comment
            })
            if (data.responseCode === 200) {
                dispatch(getUserTicketDetailsAsync(id, ticketId))
                // dispatch(SupportTicketAction.getTicketDetailsSuccess(data.responseData));
                dispatch(showSuccessSnackbar('success', data.responseMessage, defaultSnackbarTimeout));
            } else {
                dispatch(SupportTicketAction.addTicketCommentError());
                dispatch(showSuccessSnackbar('error', data.responseMessage, defaultSnackbarTimeout));
            }
        } catch (error) {
            dispatch(SupportTicketAction.addTicketCommentError(error.message));
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}